import { Container } from 'ui/components/primitives';
import { styled, theme } from 'ui/theme';

import { PaymentCard } from '../Views/Payment/components';

export const Checkout = {
  Container: styled(Container)`
    display: grid;
    gap: ${theme.space[2]};
  `,

  Component: styled(PaymentCard)`
    margin: 0 auto;
    padding-top: ${theme.space[6]};
    width: 100%;
  `,

  RadioGroup: styled('div')`
    height: ${theme.sizes[10]};
    margin-bottom: ${theme.sizes[3]};
    width: 100%;
  `,

  Title: styled('div')`
    height: ${theme.sizes[6]};
    margin-bottom: ${theme.sizes[3]};
    width: 100%;
  `,

  Button: styled('div')`
    height: ${theme.sizes[6]};
    margin-top: ${theme.space[4]};
    width: 100%;
  `,
};
